module.exports = __webpack_public_path__ + "img/nsu-75.dcbe705d.png";